/**
 * Глобальный лоадер — «гусеница» наверху страницы, ползает во время RPC-запросов.
 *
 * Анти-мерцание: если запрос завершился быстрее минимального времени показа,
 * скрытие откладывается, чтобы лоадер не моргал.
 */
class GlobalLoader {

	/**
	 * Видимость лоадера.
	 * Приватный реф: снаружи состояние меняется только через show()/hide()
	 */
	static #visible = ref(false);

	/**
	 * Время показа лоадера для расчёта минимального времени отображения
	 */
	static #startTime: Date | null = null;

	/**
	 * Минимальное время показа лоадера, мс (анти-мерцание)
	 */
	static readonly #dragMinTime = 1000;

	static get isVisible(): boolean {
		return GlobalLoader.#visible.value;
	}

	/**
	 * Показать глобальный лоадер
	 */
	static show(): void {
		GlobalLoader.#visible.value = true;
		GlobalLoader.#startTime    = new Date();
    document.body.classList.add('cursor-wait');
	}

	/**
	 * Скрыть глобальный лоадер.
	 *
	 * Если с момента показа прошло меньше минимального времени,
	 * скрытие откладывается, чтобы лоадер не моргал.
	 */
	static hide(): void {
    document.body.classList.remove('cursor-wait');
		if (GlobalLoader.#startTime === null) {
			GlobalLoader.#visible.value = false;
			return;
		}

		const diff = new Date().getTime() - GlobalLoader.#startTime.getTime();

		if (diff < GlobalLoader.#dragMinTime) {
			setTimeout(() => {
				GlobalLoader.#visible.value = false;
				GlobalLoader.#startTime    = null;
			}, GlobalLoader.#dragMinTime - diff);
		} else {
			GlobalLoader.#visible.value = false;
			GlobalLoader.#startTime    = null;
		}
	}
}

export default GlobalLoader;
